@if(isEditDatePage){
<router-outlet></router-outlet>
}@else {
<div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
  @if(myroles.can_write){
  <div class="top restaurant">
    <div class="boton">
      <button class="b1" mat-button (click)="goToMenu()">Editar menús</button>
      <button class="b1" mat-button (click)="goToEdit()">Editar fechas</button>
      <button class="b1" mat-button (click)="goToAddReservation()">
        Añadir reserva
      </button>
      <button class="b1" mat-button (click)="goToReservationConfig()">
        Editar reservas sin empleado
      </button>
      <button class="b1" mat-button (click)="openCateringSendingPopup()">
        Enviar menús catering
      </button>
      <!-- <button class="b2" type="button" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="goToReservationConfig()">
          Editar reservas sin empleado
        </button>
        <button mat-menu-item (click)="openCateringSendingPopup()">
          Enviar menús catering
        </button>
      </mat-menu> -->
    </div>
  </div>
  }
</div>
<div class="content form">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="RESERVAS">
      <app-bookings-restaurant (reservationStatsChange)="onReservationStatsChange($event)"
        (extraMenusChange)="onExtraMenusChange($event)">
      </app-bookings-restaurant>
    </mat-tab>

    <mat-tab label="CONSUMOS">
      <app-consumption-restaurant></app-consumption-restaurant>
    </mat-tab>

    <mat-tab label="CALENDARIO">
      <app-calendar-restaurant></app-calendar-restaurant>
    </mat-tab>
  </mat-tab-group>
</div>
}